import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'storfox-snackbar'
import { useNavigate } from 'react-router-dom'

import { DashboardLayout } from '~/components/Layouts'
import * as NAV from '~/constants/nav-titles'
import * as ROUTES from '~/constants/routes'

import { useAdjustmentReasonCreate } from '../../hooks/AdjustmentReason'
import AdjustmentReasonCreate from '../../components/AdjustmentReason/AdjustmentReasonCreate'

function AdjustmentReasonCreateContainer () {
  const { t } = useTranslation()
  const adjustmentReasonCreate = useAdjustmentReasonCreate()
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  const title = 'New adjustment reason'
  const message = t('Successfully created')

  const handleSubmit = formValues => {
    return adjustmentReasonCreate.create(formValues)
      .then(() => snackbar({ message }))
      .then(() => navigate(ROUTES.ADJUSTMENT_REASON_LIST_PATH))
  }

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      title={title}
      activeNav={NAV.CONFIGURATION}
      breadcrumbs={breadcrumbs}
    >
      <AdjustmentReasonCreate
        pageTitle={title}
        isLoading={adjustmentReasonCreate.isLoading}
        onSubmit={handleSubmit}
      />
    </DashboardLayout>
  )
}

export default AdjustmentReasonCreateContainer
